import { createAction, createSlice } from '@reduxjs/toolkit';

export const loadListDataRequest = createAction('list/loadListDataRequest');

const listDataSlice = createSlice({
    name: 'list',
    initialState: {},
    reducers: {
        fetchListDataStart: (state, action) => {
            const key = action.payload;
            if (!state[key]) {
                state[key] = {
                    rows: [],
                    totalCount: 0,
                    pageSize: 10,
                    offset: 0,
                    loading: true,
                    error: null,
                    cache: {},
                };
            } else {
                state[key].loading = true;
                state[key].error = null;
            }
        },
        fetchListDataSuccess: (state, action) => {
            const { key, rows, totalCount, pageSize, offset, filterHash } = action.payload;
            const currentState = state[key];
            if (currentState) {
                currentState.rows = Array.isArray(rows) ? rows : [];
                currentState.totalCount = typeof totalCount === 'number' ? totalCount : 0;
                currentState.pageSize = typeof pageSize === 'number' ? pageSize : 10;
                currentState.offset = typeof offset === 'number' ? offset : 0;
                currentState.loading = false;
                currentState.error = null;

                // Update cache with filterHash
                if (!currentState.cache[filterHash]) {
                    currentState.cache[filterHash] = {};
                }
                currentState.cache[filterHash][offset] = { rows, totalCount, pageSize };
            } else {
                state[key] = {
                    rows: Array.isArray(rows) ? rows : [],
                    totalCount: typeof totalCount === 'number' ? totalCount : 0,
                    pageSize: typeof pageSize === 'number' ? pageSize : 10,
                    offset: typeof offset === 'number' ? offset : 0,
                    loading: false,
                    error: null,
                    cache: {
                        [filterHash]: {
                            [offset]: { rows, totalCount, pageSize }
                        }
                    },
                };
            }
        },
        fetchListDataFailure: (state, action) => {
            const { key, error } = action.payload;
            if (!state[key]) {
                state[key] = {
                    rows: [],
                    totalCount: 0,
                    pageSize: 10,
                    offset: 0,
                    loading: false,
                    error: error || 'Something went wrong',
                    cache: {},
                };
            } else {
                state[key].loading = false;
                state[key].error = error || 'Something went wrong';
            }
        },
        resetListData: (state, action) => {
            const key = action.payload;
            delete state[key];
        }
    },
});

export const {
    fetchListDataStart,
    fetchListDataSuccess,
    fetchListDataFailure,
    resetListData,
} = listDataSlice.actions;

export default listDataSlice.reducer;